import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi';
import { risapi } from './risapi';

/**
 * Fetches a list of MANUAL vouchers, with filters and pagination.
 * (Unchanged)
 */
export const getVouchers = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/vouchers', filterParameters), getAxiosConfig());
        if (response.status === 200) {
            callback(response.data); // Contains { vouchers: [...] }
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

/**
 * ** NEW **
 * Fetches the list of manual voucher types (Journal, Payment, etc.)
 */
export const getVoucherTypes = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/voucher-types', filterParameters), getAxiosConfig());
        if (response.status === 200) {
            callback(response.data); // Contains { voucher_types: [...] }
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

/**
 * ** NEW **
 * Fetches a single voucher by its ID (for viewing/editing).
 */
export const fetchVoucher = async (id, callback) => {
    try {
        const response = await risapi.get(`/api/vouchers/${id}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data); // Contains { voucher: {...} }
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

/**
 * ** NEW **
 * Creates a new manual voucher.
 */
export const createVoucher = async (newData, callback) => {
    try {
        const response = await risapi.post('/api/vouchers', newData, getAxiosConfig());
        if (response.status === 201) {
            callback(response.data); // Contains { voucher: {...} }
        }
    } catch (error) {
        // Pass the full error back to the form's handleApiError
        callback({ error }); 
    }
};

/**
 * ** NEW **
 * Updates an existing manual voucher.
 */
export const updateVoucher = async (id, updateData, callback) => {
    try {
        const response = await risapi.put(`/api/vouchers/${id}`, updateData, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data); // Contains { voucher: {...} }
        }
    } catch (error) {
        // Pass the full error back to the form's handleApiError
        callback({ error }); 
    }
};

/**
 * Deletes a single voucher by its ID.
 * (Unchanged)
 */
export const destroyVoucher = async (id, callback) => {
    try {
        const response = await risapi.delete(`/api/vouchers/${id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ success: true });
        }
    } catch (error) {
        callback({ error });
    }
};